import React from 'react'
// import heroImage from "../assets/heroImage.png"
import {RiArrowRightSLine} from "react-icons/ri";
import { Link } from 'react-scroll';

function Home() {
  return (
    <div name="home" className="h-screen  w-full bg-gradient-to-b from-purple-800 to-black">
      <div className="max-w-screen-lg mx-auto flex flex-col items-center justify-center h-full px-4 md:flex-row">
        <div className="flex flex-col justify-center h-full">
         <h2 className="text-4xl sm:text-6xl font-bold text-white">
            I'm a Full Stack Developer
         </h2>
            <p className="text-gray-400 py-4 max-w-md">
            I am at my entry level in software engineering field. I am reliable, hard-working with strong attention to detail, and eager to learn about new technologies and business issues. I can work well both on my initiative and as a part of a team.
            </p>
            <div>
                <Link to="portfolio" smooth duration={500} className='group text-white w-fit px-6 py-3 my-2 flex items-center rounded-md bg-gradient-to-r from-cyan-500 to-blue-500 cursor-pointer'>
                    portfolio
                    <span className="group-hover:rotate-90 duration-300">
                    <RiArrowRightSLine size={25} className="ml-1"/>
                    </span>
                </Link>
            </div>
        </div>
        <div>
            {/* <img src={heroImage} alt="my profile" className="rounded-2xl mx-auto w-2/3 md:w-full"/> */}
        </div>
      </div>

    </div>
  )
}

export default Home
